import createStore from 'fluxible/addons/createStore';

export default createStore({
    storeName: 'ContestsActiveUserStore',
    initialize: function() {
        this.activeUser = window.activeUser;
    },
});



// WEBPACK FOOTER //
// ./src/web/js/contest/stores/contests-active-user-store.js